<template>  
    <div v-if="loading" class="loading">Loading...</div>
    <div class="relative bg-cover bg-center bg-no-repeat bg-[url('../assets/background/bg-02.png')] h-screen">
        <div class="h-full flex flex-col">
            <div class='relative h-1/6 w-auto'>
                <!-- <p class="text-8xl flex justify-start items-center text-pink-500 font-extrabold p-4" style="text-shadow: 2px 2px 8px #FF0000;">CRA Brainy</p> -->
                <!-- <img class="absolute left-4 top-4 p-4 rounded-lg xl:w-44 ld:w-44 md:w-36 sm:w-32 bg-slate-100 " src="../assets/logo/cra-logo.jpg" alt=""> -->
            </div>
            <div class='h-full flex flex-col items-center justify-end'>
                <router-link :to="`/login/`">                
                    <p @click="playBackground" class="flex justify-center items-center w-full p-4 bg-sky-500 mb-32 text-white font-bold xl:text-6xl lg:text-6xl md:text-4xl sm:text-2xl rounded-lg animate-bounce shadow-lg hover:ring-4 hover:ring-bg-sky-100">เข้าเล่นเกมกันเถอะ</p>
                </router-link>
            </div>
        </div>        
    </div>         
</template>

<script>
import soundBackground from '.././js/sound-background';
export default {
    name: "Home",    
    data() {
      return {
        pathSound: '../assets/sound/Brendan_Kinsella_-_Mozart.mp3'
      }
    },
    methods: {
      playBackground() {
        soundBackground();
      }
    }    
};
</script>